import { render, staticRenderFns } from "./BlackListsFilter.vue?vue&type=template&id=11750ec8&"
import script from "./BlackListsFilter.vue?vue&type=script&lang=ts&"
export * from "./BlackListsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports